
import { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import storage from '../services/storage';
import { useDispatch } from 'react-redux';
import { resetAuth } from '../Store/auth/authReducer';

export const ProfileDropdown = ({ user = {}, from = 'instructor' }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    storage.remove('user');
    storage.remove('class');
    storage.remove('status');
    storage.remove('sectionId');
    storage.remove('xAuthToken');
    storage.remove('lastBookId');
    storage.remove('searchParams');
    dispatch(resetAuth());
    navigate('/', { replace: true, state: { fromState: from } });
  };
  
  return (
    <Dropdown className='customized-dropdown'>
      <Dropdown.Toggle
        as={forwardRef(({ onClick, props }, ref) => (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            href=""
            ref={ref}
            onClick={(e) => {
              e.preventDefault();
              onClick(e);
            }}
            {...props}
            style={{
              marginRight: from === 'instructor' ? '10px': "",
            }}
            className='profile-tag d-flex align-items-center zIndex-999 text-decoration-none'
          >
            {user?.image ? (
              <img
                src={user.image}
                className='user_img_cre'
                alt='profile_photo'
              />
            ) : (
              <div className='profilePicture fs-16'>
                {user?.firstName?.[0]}
                {user?.lastName?.[0]}
              </div>
            )}
          </a>
        ))}
        id='dropdown-custom-components dropdown-button-drop-left'
      />

      <Dropdown.Menu className='zIndex profile-menu'>
        <Dropdown.Item as="button" className='d-flex py-2 px-2 gap-3 align-items-center text-uppercase profile-item' onClick={() => navigate(user.role === 'STUDENT' ? '/studentdashboard/settings' : '/dashboard/settings')}>
          <img className='me-0' src="/assets/icons/settings.svg" alt="ico here" />
          <span className='settings-span'>Settings</span>
        </Dropdown.Item>

        <Dropdown.Item as="button" className='d-flex py-2 px-2 gap-3 align-items-center text-uppercase profile-item' onClick={logout}>
          <img className='me-0' src="/assets/icons/log-out.svg" alt="ico here" />
          <span className='settings-span'>Signout</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
